import type { InputHTMLAttributes } from "react"

import {
  useFormContext,
  type FieldPath,
  type FieldValues,
} from "react-hook-form"

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form"
import { PhoneInput } from "@/components/ui/phone-input"

export type Props<T extends FieldValues = FieldValues> = {
  name: FieldPath<T>
  label?: string
  placeholder: string
  disabled?: boolean
} & Omit<
  InputHTMLAttributes<HTMLInputElement>,
  "name" | "value" | "onChange" | "onBlur" | "ref" | "defaultValue"
>

export function FormInputPhone<T extends FieldValues = FieldValues>({
  name,
  label,
  disabled,
  ...props
}: Props<T>) {
  const form = useFormContext<T>()

  return (
    <FormField
      control={form.control}
      name={name}
      disabled={disabled}
      render={({ field }) => (
        <FormItem className="w-full">
          {label && <FormLabel>{label}</FormLabel>}
          <FormControl>
            <PhoneInput
              defaultCountry="US"
              initialValueFormat="national"
              {...props}
              {...field}
            />
          </FormControl>
          <FormMessage className="form-error" />
        </FormItem>
      )}
    />
  )
}
